import React from 'react';
import styled from 'styled-components';

import { DropdownMenu } from '@/components/common';
import { TabletAndDesktop } from '@/breakpoints-config/breakpoints';

interface IProps {
  label: string;
  dropdownConfig: {
    options: {
      label: string;
      callback: React.MouseEventHandler<Element>;
    }[];
    separators?: number[];
  };
}

const ResourceDatabaseTitleAction = ({ label, dropdownConfig }: IProps): React.ReactElement => {
  return (
    <Container>
      <TabletAndDesktop>
        <Label>{label}</Label>
      </TabletAndDesktop>
      <StyledDropdown {...dropdownConfig} />
    </Container>
  );
};

export { ResourceDatabaseTitleAction };

const Container = styled.div`
  padding-right: 16px;
  display: flex;
  align-items: center;
  align-self: baseline;
`;

const StyledDropdown = styled(DropdownMenu)`
  width: 24px;
`;

const Label = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: #37415180;
  margin-right: 12px;
  white-space: nowrap;
`;
